import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../components/Login/login";
import HomePage from "../components/homepage/homepage";
import NotFound from "../components/NotFound/NotFound";
import ChatBot from "../components/ChatBot/chatbot";

// Wrapper to extract params from URL and pass to ChatBot
const ChatBotWrapper = () => {
  const { company_name } = useParams();
  return <ChatBot companyName={decodeURIComponent(company_name)} />;
};

const AppRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Router>
      <Routes>
        <Route path="/" element={isAuthenticated ? <HomePage /> : <Login />} />
        <Route path="/dashboard" element={isAuthenticated ? <HomePage /> : <Navigate to="/" />} />
        <Route path='/talk/:company_name' element={<ChatBotWrapper />} />
        <Route path="*" element={<NotFound />} /> {/* Keep this at the bottom */}
      </Routes>
    </Router>
  );
};

export default AppRoute;
